import api from '@/utils/api'
import { constructFilter } from '@/utils/servicesUtil'

export default {
    getAllSMSCampaigns(filters) {
        return api.get(`sms-campaigns${constructFilter(filters)}`)
    },
    duplicateSMSCampaign(id) {
        return api.post(`sms-campaigns/${id}/duplicate`)
    },
    createSMSCampaign(campaign) {
        return api.post('sms-campaigns', campaign)
    },
    updateSMSCampaign(campaign) {
        return api.put(`sms-campaigns/${campaign.id}`, campaign)
    },
    uploadSMSCampaignFile(id, data) {
        return api.post(`sms-campaigns/${id}/import-file`, data)
    },
    submitSMSCampaign(id) {
        return api.put(`sms-campaigns/${id}/submit`)
    },
    getSMSCampaignById(id) {
        return api.get(`sms-campaigns/${id}`)
    },
    getSMSCampaignProgress(id) {
        return api.get(`sms-campaigns/${id}/progress`)
    },
    getSMSCampaignStatusMessages(id) {
        return api.get(`sms-campaigns/${id}/status-count`)
    },
    getSMS(id, filters) {
        return api.get(`sms-campaigns/${id}/sms${constructFilter(filters)}`)
    },
    getSMSCampaignReport(id) {
        return api.get(`sms-campaigns/${id}/export`)
    },
    updateSMSCampaignStatus(id, status) {
        return api.put(`sms-campaigns/${id}/pause/${status}`)
    },
    downloadUploadedFile(id) {
        return api.get(`downloads/sms-campaigns/${id}`)
    },
    sentTestSMSCampaign(id, testListId) {
        return api.post(`sms-campaigns/${id}/send-test/list-id/${testListId}`)
    },
    deleteSMSCampaign(id) {
        return api.delete(`/sms-campaigns/${id}`)
    }
}
